var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabs && Array.isArray(_vm.tabs) && _vm.tabs.length > 0)?_c('div',{staticClass:"d-flex"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:((tab.path) + "_tab")},[_c('router-link',{attrs:{"to":("" + (tab.path))},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('div',{on:{"click":function($event){return _vm.handleClickTab(tab)}}},[_c('b-link',{class:[
          'nav__link',
          isActive && 'nav__link--active global-primary__bg' ],attrs:{"active":isActive,"href":href},on:{"click":navigate}},[_vm._v(_vm._s(tab.name))])],1)]}}],null,true)})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }